import { ReactNode } from 'react'
import { Modal as MuiModal, ButtonBase, Card } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

type Props = {
  open: boolean
  onClose: () => void
  children: ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  styles?: Record<string, any>
  maxWidth?: number | string
}

const defaultStyles = {
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '90%',
    boxShadow: 24,
    overflowY: 'auto'
  },
  button: {
    position: 'absolute',
    right: 0,
    width: 40,
    height: 40
  }
}

const Modal = ({
  open,
  onClose,
  children,
  styles = defaultStyles,
  maxWidth = 600
}: Props) => {
  return (
    <MuiModal open={open} onClose={onClose}>
      <Card
        sx={{
          ...defaultStyles.container,
          ...styles.container,
          maxWidth
        }}
      >
        <ButtonBase
          data-testid="modal-close-button"
          sx={{ ...defaultStyles.button, ...styles.button }}
          onClick={onClose}
        >
          <CloseIcon />
        </ButtonBase>
        {children}
      </Card>
    </MuiModal>
  )
}

export default Modal
